import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-26c21dc5"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content-shape container pt-4"
};
var _hoisted_2 = {
  class: "d-flex flex-row justify-content-between mt-2"
};
var _hoisted_3 = {
  class: "user d-flex flex-row align-items-center flex-fill"
};
var _hoisted_4 = {
  class: "details flex-fill"
};
var _hoisted_5 = {
  class: "name"
};
var _hoisted_6 = {
  class: "created-on"
};
var _hoisted_7 = {
  key: 0
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" In ");

var _hoisted_9 = {
  class: "actions pt-1"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode("Delete");

var _hoisted_11 = /*#__PURE__*/_createTextVNode("Reported");

var _hoisted_12 = /*#__PURE__*/_createTextVNode(" You have already reported this message ");

var _hoisted_13 = /*#__PURE__*/_createTextVNode("Report");

var _hoisted_14 = {
  class: "mt-4 pt-1"
};
var _hoisted_15 = {
  class: "d-inline-block"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "px-2"
  }, "·", -1);
});

var _hoisted_17 = {
  class: "d-inline-block"
};

var _hoisted_18 = /*#__PURE__*/_createTextVNode(" Key ");

var _hoisted_19 = /*#__PURE__*/_createTextVNode("Copy");

var _hoisted_20 = /*#__PURE__*/_createTextVNode("Content");

var _hoisted_21 = /*#__PURE__*/_createTextVNode("Try again");

var _hoisted_22 = {
  class: "user d-flex flex-row align-items-center mt-2"
};
var _hoisted_23 = {
  class: "details"
};

var _hoisted_24 = /*#__PURE__*/_createTextVNode(" Reason · ");

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("small", null, "(Optional)", -1);
});

var _hoisted_26 = /*#__PURE__*/_createTextVNode(" Submit report ");

var _hoisted_27 = /*#__PURE__*/_createTextVNode("Cancel");

import { ref, reactive, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { DateTime } from "luxon";
import { useDialog, useLoadingBar, useMessage } from "naive-ui";
import { LockOpenOutline, ShareSocialOutline } from "@vicons/ionicons5";
import { UseTimeAgo } from "@vueuse/components";
import { useUserStore } from "@/store/user";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import { getTitle } from "@/router/helpers";
import { ReportModel, ReportValidator } from "@/schemes/message";
import { getErrorMessage, handleError } from "@/utils/errors";
import { useIsMobile } from "@/utils/reactive";
import Avatar from "@/components/users/Avatar.vue";
import Link from "@/components/utils/Link.vue";
import MessageSourcesAction from "@/components/messages/MessageSourcesAction.vue";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var userStore = useUserStore();
    var loadingBar = useLoadingBar();
    var dialogAPI = useDialog();
    var messageAPI = useMessage();
    var isMobile = useIsMobile();
    var LoaderState = LoaderStateEnum;
    var loaders = reactive({
      fetch: LoaderStateEnum.Idle,
      report: LoaderStateEnum.Idle
    });
    var errors = reactive({});
    var models = reactive({
      report: _objectSpread({}, ReportModel)
    });
    var rules = {
      report: ReportValidator
    };
    var form = ref(null);
    var message = ref(null);
    var notFound = ref(false);
    var reportModalVisible = ref(false);
    var isOwner = computed(function () {
      var _message$value, _message$value$create, _userStore$user;

      return userStore.authenticated && ((_message$value = message.value) === null || _message$value === void 0 ? void 0 : (_message$value$create = _message$value.createdByUser) === null || _message$value$create === void 0 ? void 0 : _message$value$create.id) === ((_userStore$user = userStore.user) === null || _userStore$user === void 0 ? void 0 : _userStore$user.id);
    });

    var load = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var key, _yield$http$get, resource;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loadingBar.start();
                loaders.fetch = LoaderStateEnum.Loading;
                key = route.query.k;
                _context2.prev = 3;

                if (!(typeof key !== "string" || key.trim().length === 0)) {
                  _context2.next = 6;
                  break;
                }

                throw {
                  response: {
                    status: 404
                  }
                };

              case 6:
                _context2.next = 8;
                return http.get("/messages", {
                  params: {
                    key: key
                  }
                });

              case 8:
                _yield$http$get = _context2.sent;
                resource = _yield$http$get.data;
                message.value = resource;
                document.title = getTitle(resource.key);
                loaders.fetch = LoaderStateEnum.Loaded;
                loadingBar.finish();

                if (route.query.action === "report") {
                  onReport();
                }

                _context2.next = 24;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](3);
                _context2.next = 21;
                return handleError(_context2.t0, {
                  placeholder: "The requested data is currently inaccessible.",
                  http: function () {
                    var _http = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, placeholder) {
                      var _e$response, _e$response2, _e$response2$data;

                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              notFound.value = (e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 404;

                              if (!(route.query.auth === "1" && !userStore.authenticated)) {
                                _context.next = 4;
                                break;
                              }

                              _context.next = 4;
                              return router.push({
                                name: "Signin",
                                query: {
                                  to: route.fullPath
                                }
                              });

                            case 4:
                              return _context.abrupt("return", notFound.value ? "The requested message was not found." : getErrorMessage((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.errors, placeholder));

                            case 5:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    function http(_x, _x2) {
                      return _http.apply(this, arguments);
                    }

                    return http;
                  }()
                });

              case 21:
                errors.fetch = _context2.sent;
                loaders.fetch = LoaderStateEnum.Failed;
                loadingBar.error();

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 17]]);
      }));

      return function load() {
        return _ref.apply(this, arguments);
      };
    }();

    var onRemove = function onRemove() {
      var dialog = dialogAPI.warning({
        title: "Warning",
        content: "This message will be permanently deleted. Are you sure you want to continue?",
        positiveText: "Delete",
        negativeText: "Cancel",
        onPositiveClick: function () {
          var _onPositiveClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    dialog.loading = true;
                    _context3.next = 3;
                    return remove();

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function onPositiveClick() {
            return _onPositiveClick.apply(this, arguments);
          }

          return onPositiveClick;
        }()
      });
    };

    var remove = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                loadingBar.start();
                _context4.prev = 1;

                if (message.value) {
                  _context4.next = 4;
                  break;
                }

                throw new Error("Message not found");

              case 4:
                _context4.next = 6;
                return http.delete("/messages/".concat(message.value.messageId));

              case 6:
                loadingBar.finish();
                _context4.next = 9;
                return router.push({
                  name: "Messages"
                });

              case 9:
                messageAPI.success("The message has been deleted");
                _context4.next = 20;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](1);
                loadingBar.error();
                _context4.t1 = messageAPI;
                _context4.next = 18;
                return handleError(_context4.t0, {
                  placeholder: "There was an error during the deletion"
                });

              case 18:
                _context4.t2 = _context4.sent;

                _context4.t1.error.call(_context4.t1, _context4.t2);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 12]]);
      }));

      return function remove() {
        return _ref2.apply(this, arguments);
      };
    }();

    var onReport = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _message$value2;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (userStore.authenticated) {
                  _context5.next = 4;
                  break;
                }

                _context5.next = 3;
                return reportRedirect();

              case 3:
                return _context5.abrupt("return");

              case 4:
                if (!isOwner.value) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return");

              case 6:
                if (!((_message$value2 = message.value) !== null && _message$value2 !== void 0 && _message$value2.reportedByUser)) {
                  _context5.next = 9;
                  break;
                }

                dialogAPI.success({
                  title: "Reported",
                  content: "You have already reported this message",
                  positiveText: "Ok",
                  onMaskClick: function onMaskClick() {
                    return onReportClosed();
                  },
                  onClose: function onClose() {
                    return onReportClosed();
                  },
                  onPositiveClick: function onPositiveClick() {
                    return onReportClosed();
                  }
                });
                return _context5.abrupt("return");

              case 9:
                reportModalVisible.value = true;

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function onReport() {
        return _ref3.apply(this, arguments);
      };
    }();

    var onReportClosed = function onReportClosed() {
      models.report = _objectSpread({}, ReportModel);
      if (route.query.action !== "report") return;

      var query = _objectSpread({}, route.query);

      delete query.action;
      router.replace({
        query: query
      });
    };

    var reportRedirect = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var url, to;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                url = new URL("".concat(window.location.origin).concat(route.fullPath));
                url.searchParams.set("action", "report");
                to = url.toString().replace(window.location.origin, "");
                _context6.next = 5;
                return router.push({
                  name: "Signin",
                  query: {
                    to: to
                  }
                });

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function reportRedirect() {
        return _ref4.apply(this, arguments);
      };
    }();

    var report = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _payload$reason, payload;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(!message.value || !form.value)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                _context7.prev = 2;
                _context7.next = 5;
                return form.value.validate();

              case 5:
                _context7.next = 10;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](2);
                return _context7.abrupt("return", false);

              case 10:
                loaders.report = LoaderStateEnum.Loading;
                _context7.prev = 11;
                payload = _objectSpread({
                  key: message.value.key
                }, models.report);

                if (((_payload$reason = payload.reason) === null || _payload$reason === void 0 ? void 0 : _payload$reason.length) === 0) {
                  delete payload.reason;
                }

                _context7.next = 16;
                return http.post("/messages/report", payload);

              case 16:
                message.value.reportedByUser = true;
                reportModalVisible.value = false;
                loaders.report = LoaderStateEnum.Idle;
                messageAPI.success("This message has been reported");
                _context7.next = 28;
                break;

              case 22:
                _context7.prev = 22;
                _context7.t1 = _context7["catch"](11);
                _context7.next = 26;
                return handleError(_context7.t1);

              case 26:
                errors.report = _context7.sent;
                loaders.report = LoaderStateEnum.Failed;

              case 28:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[2, 7], [11, 22]]);
      }));

      return function report() {
        return _ref5.apply(this, arguments);
      };
    }();

    var copy = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                if (message.value) {
                  _context8.next = 3;
                  break;
                }

                throw new Error("Message not found");

              case 3:
                _context8.next = 5;
                return navigator.clipboard.writeText(message.value.key);

              case 5:
                messageAPI.success("The key has been copied");
                _context8.next = 11;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](0);
                messageAPI.error("The key could not be copied");

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 8]]);
      }));

      return function copy() {
        return _ref6.apply(this, arguments);
      };
    }();

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (!(!userStore.authenticated && route.query.action === "report")) {
                _context9.next = 4;
                break;
              }

              _context9.next = 3;
              return reportRedirect();

            case 3:
              return _context9.abrupt("return");

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    })));
    load();
    return function (_ctx, _cache) {
      var _component_n_button = _resolveComponent("n-button");

      var _component_n_tooltip = _resolveComponent("n-tooltip");

      var _component_n_icon = _resolveComponent("n-icon");

      var _component_n_text = _resolveComponent("n-text");

      var _component_n_h2 = _resolveComponent("n-h2");

      var _component_n_layout = _resolveComponent("n-layout");

      var _component_n_p = _resolveComponent("n-p");

      var _component_n_result = _resolveComponent("n-result");

      var _component_n_skeleton = _resolveComponent("n-skeleton");

      var _component_n_input = _resolveComponent("n-input");

      var _component_n_form_item = _resolveComponent("n-form-item");

      var _component_n_alert = _resolveComponent("n-alert");

      var _component_n_form = _resolveComponent("n-form");

      var _component_n_modal = _resolveComponent("n-modal");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(loaders).fetch !== _unref(LoaderState).Loading ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(loaders).fetch !== _unref(LoaderState).Failed ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [message.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("header", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(Avatar, {
        user: message.value.createdByUser,
        size: 72,
        class: "avatar me-3"
      }, null, 8, ["user"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("strong", null, _toDisplayString(message.value.createdByUser.userName), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("small", null, [_createVNode(_unref(UseTimeAgo), {
        time: _unref(DateTime).fromISO(message.value.creationDate, {
          zone: 'UTC'
        }).toJSDate()
      }, {
        default: _withCtx(function (_ref8) {
          var timeAgo = _ref8.timeAgo;
          return [_createTextVNode(" Posted " + _toDisplayString(timeAgo), 1)];
        }),
        _: 1
      }, 8, ["time"])])]), message.value.groups && message.value.groups.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("small", null, [_hoisted_8, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.value.groups, function (group) {
        return _openBlock(), _createBlock(Link, {
          key: group.groupId,
          to: {
            name: 'Group',
            params: {
              id: group.groupId
            }
          }
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(group.name), 1)];
          }),
          _: 2
        }, 1032, ["to"]);
      }), 128))])])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_9, [_unref(isOwner) ? (_openBlock(), _createBlock(_component_n_button, {
        key: 0,
        type: "error",
        onClick: onRemove
      }, {
        default: _withCtx(function () {
          return [_hoisted_10];
        }),
        _: 1
      })) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [message.value.reportedByUser ? (_openBlock(), _createBlock(_component_n_tooltip, {
        key: 0,
        trigger: "hover",
        disabled: _unref(isMobile)
      }, {
        trigger: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            type: "error",
            tag: "div",
            ghost: "",
            disabled: !_unref(isMobile),
            class: "reported",
            onClick: onReport
          }, {
            default: _withCtx(function () {
              return [_hoisted_11];
            }),
            _: 1
          }, 8, ["disabled"])];
        }),
        default: _withCtx(function () {
          return [_hoisted_12];
        }),
        _: 1
      }, 8, ["disabled"])) : (_openBlock(), _createBlock(_component_n_button, {
        key: 1,
        type: "warning",
        onClick: onReport
      }, {
        default: _withCtx(function () {
          return [_hoisted_13];
        }),
        _: 1
      }))], 64))])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_n_icon, {
        class: "me-1"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(LockOpenOutline), {
            class: "align-top"
          })];
        }),
        _: 1
      }), _createElementVNode("small", null, [_createVNode(_component_n_text, {
        depth: "3"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("Decoded " + _toDisplayString(message.value.nbParse) + " times", 1)];
        }),
        _: 1
      })])]), _hoisted_16, _createElementVNode("div", _hoisted_17, [_createVNode(MessageSourcesAction, {
        mkey: message.value.key,
        loaded: message.value.sources
      }, {
        action: _withCtx(function (_ref9) {
          var trigger = _ref9.trigger;
          return [_createVNode(_component_n_button, {
            secondary: "",
            type: "primary",
            size: "tiny",
            class: "align-bottom",
            onClick: trigger
          }, {
            icon: _withCtx(function () {
              return [_createVNode(_component_n_icon, null, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(ShareSocialOutline))];
                }),
                _: 1
              })];
            }),
            default: _withCtx(function () {
              return [_createTextVNode(" View sources (" + _toDisplayString(message.value.sources.length) + ") ", 1)];
            }),
            _: 2
          }, 1032, ["onClick"])];
        }),
        _: 1
      }, 8, ["mkey", "loaded"])])]), _createVNode(_component_n_h2, {
        class: "d-flex flex-row align-items-center"
      }, {
        default: _withCtx(function () {
          return [_hoisted_18, _createVNode(_component_n_button, {
            type: "info",
            size: "small",
            class: "ms-2",
            secondary: "",
            onClick: copy
          }, {
            default: _withCtx(function () {
              return [_hoisted_19];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createElementVNode("div", null, [_createVNode(_component_n_layout, {
        embedded: "",
        class: "key p-3 rounded-3 text-center"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(message.value.key), 1)];
        }),
        _: 1
      })]), _createVNode(_component_n_h2, null, {
        default: _withCtx(function () {
          return [_hoisted_20];
        }),
        _: 1
      }), _createVNode(_component_n_p, {
        class: "content white-space-pre-line"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(message.value.content), 1)];
        }),
        _: 1
      })], 64)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createBlock(_component_n_result, {
        key: 1,
        status: "error",
        title: notFound.value ? 'Not found' : 'Error',
        description: _unref(errors).fetch
      }, _createSlots({
        _: 2
      }, [!notFound.value ? {
        name: "footer",
        fn: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return load();
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_21];
            }),
            _: 1
          })];
        })
      } : undefined]), 1032, ["title", "description"]))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_n_skeleton, {
        sharp: false,
        class: "skeleton-item avatar me-3"
      }), _createElementVNode("div", _hoisted_23, [_createVNode(_component_n_skeleton, {
        size: "small",
        class: "skeleton-item name mb-2"
      }), _createVNode(_component_n_skeleton, {
        class: "skeleton-item created-on"
      })])]), _createVNode(_component_n_h2, {
        class: "d-flex flex-row align-items-center"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_skeleton, {
            size: "small",
            class: "skeleton-item key-title"
          }), _createVNode(_component_n_skeleton, {
            sharp: false,
            size: "small",
            class: "skeleton-item copy ms-2"
          })];
        }),
        _: 1
      }), _createVNode(_component_n_skeleton, {
        sharp: false,
        class: "skeleton-item key"
      }), _createVNode(_component_n_h2, {
        class: "pb-2"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_skeleton, {
            size: "small",
            class: "skeleton-item content-title"
          })];
        }),
        _: 1
      }), _createVNode(_component_n_p, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_skeleton, {
            class: "skeleton-item content",
            style: {
              'width': '35%'
            }
          }), _createVNode(_component_n_skeleton, {
            class: "skeleton-item content",
            repeat: 8
          }), _createVNode(_component_n_skeleton, {
            class: "skeleton-item content",
            style: {
              'width': '60%'
            }
          })];
        }),
        _: 1
      })], 64)), message.value && !_unref(isOwner) ? (_openBlock(), _createBlock(_component_n_modal, {
        key: 2,
        show: reportModalVisible.value,
        "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
          return reportModalVisible.value = $event;
        }),
        "auto-focus": !_unref(isMobile),
        preset: "card",
        title: "Message report",
        onAfterLeave: onReportClosed
      }, {
        footer: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            type: "primary",
            loading: _unref(loaders).report === _unref(LoaderState).Loading,
            onClick: report
          }, {
            default: _withCtx(function () {
              return [_hoisted_26];
            }),
            _: 1
          }, 8, ["loading"]), _createVNode(_component_n_button, {
            class: "ms-2",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return reportModalVisible.value = false;
            }),
            disabled: _unref(loaders).report === _unref(LoaderState).Loading
          }, {
            default: _withCtx(function () {
              return [_hoisted_27];
            }),
            _: 1
          }, 8, ["disabled"])];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_n_form, {
            model: _unref(models).report,
            ref_key: "form",
            ref: form,
            rules: rules.report
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_form_item, {
                path: "reason",
                label: "Reason"
              }, {
                label: _withCtx(function () {
                  return [_hoisted_24, _hoisted_25];
                }),
                default: _withCtx(function () {
                  return [_createVNode(_component_n_input, {
                    "input-props": {
                      autocomplete: 'off'
                    },
                    value: _unref(models).report.reason,
                    "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
                      return _unref(models).report.reason = $event;
                    }),
                    placeholder: "Please tell us why do you think this content is inappropriate.",
                    type: "textarea",
                    autosize: {
                      minRows: 2
                    }
                  }, null, 8, ["value"])];
                }),
                _: 1
              }), _unref(loaders).report === _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_alert, {
                key: 0,
                type: "error",
                class: "white-space-pre-line",
                "show-icon": false
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref(errors).report), 1)];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["model", "rules"])];
        }),
        _: 1
      }, 8, ["show", "auto-focus"])) : _createCommentVNode("", true)]);
    };
  }
});